import React, { Component } from 'react'
import GlitchText from 'react-glitch-effect/core/GlitchText';
import Typewriter from 'typewriter-effect';
import RotatingCubeFace  from './threejs-fiber/rotatingCubeFace/rotatingCubeFace.js'
import AnimatedBackground from '../components/AnimatedBackground.js';
import '../App.css'
import 'animate.css';

import { Text, LanguageContext } from '../store/LanguageContext/LanguageContext.js';

export class Home extends Component {
  
  static contextType = LanguageContext
  
  state = { width: window.innerWidth, height: window.innerHeight, ctx: this.context }

  constructor(props) {
    super(props);
    this.portugueseName = React.createRef();
    this.deutschName = React.createRef();
    this.englishName = React.createRef();
    
  }

  setNameColorAnimation() {

    const values = [
      'rgba(9, 5, 254, 0.984)',
      'rgba(254, 22, 5, 0.986)',
      'rgba(254, 217, 5, 0.986)',
      'rgba(254, 250, 5, 0.986)',
      'rgba(217, 254, 5, 0.986)',
      'rgba(84, 254, 5, 0.986)',
      'rgba(5, 254, 179, 0.986)',
      'rgba(5, 254, 242, 0.986)',
      'rgba(5, 175, 254, 0.986)',
      'rgba(183, 5, 254, 0.986)'
    ]

    let index = 1, ls = this

    setInterval(() => {
      let refToUse
      if (this.context && this.context.userLanguage == 'pt') {
        refToUse = this.portugueseName.current
      } else if (this.context && this.context.userLanguage == 'dt') { 
        refToUse = this.deutschName.current
      } else {
        refToUse = this.englishName.current
      }

      if (refToUse && refToUse.style) {

        refToUse.style.textShadow =
          `rgb(255, 255, 255) 0px 0px 7.6px, ${values[index]} 0px 0px 30.4px, rgb(254, 5, 225) 0px 0px 45.6px`

        index++

        if (index == 9) index = 0

      }

    }, 2000);

  }

  componentDidMount() {
    document.title = 'My react built portfolio. Enjoy it!'
    window.addEventListener('resize', () => {
      this.setState({ width: window.innerWidth, height: window.innerHeight })
    })
    
    this.setNameColorAnimation()

  }

  componentWillUnmount() {
    window.removeEventListener('resize', null)
  }
  isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ? 'true' : 'false'
  }
  
  render() {
    let about
    
    if (this.context && this.context.userLanguage == 'pt') {
      about = <div id="portuguese-explanation">
          <h3 
            ref={this.portugueseName} 
            className="animated-shadow"
          >
            <GlitchText component='span' disabled={false}>
              Eu sou Adriel.
            </GlitchText>
            <Typewriter
              options={{
                strings: ['FullStack', 'WebDeveloper'],
                autoStart: true,
                loop: true,
              }}
            />
          </h3>
          <div className="animated-background">
            <div className="moving-background">
              {AnimatedBackground()} 
            </div>
            <p style={{zIndex: 5}}>
              Esse site foi construído usando React.js, React Router, Material design para React.js
              Eu sou fan de Vue.js, mas adotei o desafio de desenvolver em React.js também e estou
              gostando muito
            </p>
          </div>
          <br />
          <br />
          <a href="mailto:adrielwerlich@gmail.com" target="_blank" style={{zIndex: 5}}>
            Se você precisa de um dev Vue.js ou React.js
            para construção de aplicações web modernas entre em contato comigo através do meu email
            clicando aqui
          </a>
          <br />
          <br />
            ou através
          <br />
          <br />
          <a href="https://www.linkedin.com/in/adriel-werlich-61430428/"
            target="_blank"
          >
            Perfil no Linkedin
          </a>
        </div>
    } else if (this.context && this.context.userLanguage == 'de') {
      about = <div id="german-explanation">
        <h3 
          ref={this.deutschName}
          className="animated-shadow"  
        >
          <GlitchText component='span' disabled={false}>
            Ich bin Adriel.
          </GlitchText>
          <Typewriter
            options={{
              strings: ['FullStack', 'Webentwickler'],
              autoStart: true,
              loop: true,
            }}
          />
        </h3>
        <div className="animated-background">
            <div className="moving-background">
              {AnimatedBackground()} 
            </div>
            <p>
              Diese Website wurde mit React.js, React Router, Material Design für React.js erstellt. Ich bin Vue.js-Fan, aber React.js ist auch eine schöne Herausforderung. Ich mag Herausforderungen beim Programmieren
            </p>
        </div>
        <br />
        <br />
        <a href="mailto:adrielwerlich@gmail.com" target="_blank">
          Wenn Sie einen Vue.js- oder React.js-Entwickler für Ihre Webanwendungsanforderungen benötigen, kontaktieren Sie mich über meine E-Mail. Klicken Sie einfach hier
        </a>
        <br />
        <br />
          oder durch
        <br />
        <br />
        <a href="https://www.linkedin.com/in/adriel-werlich-61430428/"
          target="_blank"
        >
          Klicken Sie hier für Mein Linkedin-Profil
        </a>
      </div>
    } else {
      about = <div id="english-explanation">
        
          <h3 
            ref={this.englishName}
            className="animated-shadow"  
          >
            <GlitchText component='span' disabled={false}>
              I´m Adriel.
            </GlitchText>
            <Typewriter
                options={{
                  strings: ['FullStack', 'WebDeveloper'],
                  autoStart: true,
                  loop: true,
                }}
              />
             
          </h3>
          <div className="animated-background">
            <div className="moving-background">
              {AnimatedBackground()} 
            </div>
            <p>
              This website is made with React.js, React Router, Material design for React.js
              I´m Vue.js fan, however, React.js is also nice challenge. I like programming
              challenges
            </p>
          </div>
            <br />
            <br />
            <a href="mailto:adrielwerlich@gmail.com"> If you need a Vue.js or a React.js
            developer for you web application requirements get in touch with me through
            my email. Just Click here </a>
            <br />
            <br />
            or through
            <br />
            <br />
            <a href="https://www.linkedin.com/in/adriel-werlich-61430428/"
              target="_blank"
            >
              Click Here for My Linkedin profile
            </a>
        </div>
    }
    return (
        <div id="home-page-component">
          <div id="rotating-cube-face" style={{ position: 'fixed', right: '0%'}}>
            <RotatingCubeFace />
          </div>
          
          <div id="about" style={{margin: '4% 0 0 0'}}>
            {about}
          </div>
          <br/>
          <div id="showing-window-resize">
            <span>Window size: {this.state.width} x {this.state.height}</span>;
            <br/>
            <span>Is mobile device? {this.isMobile()}</span>
          </div>
        </div>
      
    )
  }
}

export default Home